const RESERVED = new Set(['www', 'app', 'api', 'admin', 'mail', 'support', 'help', 'brix'])

export class TenantSlug {
  private readonly value: string

  private constructor(value: string) {
    this.value = value
  }

  static from(raw: string): TenantSlug {
    const slug = raw
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')

    if (slug.length < 3) throw new Error('Slug must be at least 3 characters')
    if (slug.length > 48) throw new Error('Slug must be 48 characters or less')
    if (RESERVED.has(slug)) throw new Error(`"${slug}" is a reserved name`)

    return new TenantSlug(slug)
  }

  toString(): string {
    return this.value
  }

  equals(other: TenantSlug): boolean {
    return this.value === other.value
  }
}
